import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { AccountsGridController } from '../controller/AccountsGridController';

export class AccountsGridWebComponent extends BaseWebComponentElement {
  public controller: AccountsGridController | null;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: AccountsGridController,
    });
  }
}
